import React from "react";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";
import { ActiveAvitoContainer } from "../../components/ActiveAvitoContainer/ActiveAvitoContainer";

const ActiveAvitoScreen = () => {
  return (
    <ScreenLayout>
      <ActiveAvitoContainer />
    </ScreenLayout>
  );
};

export default ActiveAvitoScreen;
